import classnames from 'classnames';
import { FC, RefAttributes, SVGProps } from 'react';

import styles from './icon.module.scss';
import { IconProps, IconType } from './icon.types';

export const Icon =
  (
    IconElementFill: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>,
    IconElementLine: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>
  ): IconType =>
  ({ variant = 'line', size, color, className, ...props }: IconProps) => {
    const IconElement = variant === 'fill' ? IconElementFill : IconElementLine;
    return (
      <IconElement
        className={classnames(
          styles.icon,
          className,
          color && styles[color],
          styles[size ?? 'defaultSize']
        )}
        {...props}
      />
    );
  };
